module.exports = __webpack_public_path__ + "img/0_1.ce93b339.jpg";